import { PHONE_REGEX } from '@zoopla/shared/forms';

// 070 and 076 are premium numbers (except 07624 which are Isle of Man phone numbers)
const BLOCKED_PHONE_REGEX = /^(((\+|00)440?)|0)(?:76(?!24)|70).*$/;

export const isBlockedPhoneNumber = (phoneNumber: string): boolean => {
    // Removing the whitespace makes the blocked phone regex much simpler and negates
    // attempts to circumvent the check by flooding the number with spaces/punctuation.
    const normalisedPhoneNumber = phoneNumber.replace(/[\s\-()]/g, '');
    return BLOCKED_PHONE_REGEX.test(normalisedPhoneNumber);
};

export const isValidPhoneNumber = (phoneNumber: string): boolean => {
    return !isBlockedPhoneNumber(phoneNumber) && PHONE_REGEX.test(phoneNumber);
};
